<template>
  <el-dialog
    class="dialog-form"
    append-to-body
    :visible.sync="visibleWarranty"
    title="Thêm bảo hành"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closePopup"
  >
    <validation-observer ref="observerWarranty" id="observerWarranty">
      <form>
        <LayoutFieldSet type="block" >
          <LayoutField type="block" :required="true">
            <template #label>Tên chính sách bảo hành </template>
            <template #input>
              <BaseInput
                placeholder="Nhập tên chính sách bảo hành"
                v-model="name"
                name="Tên chính sách bảo hành"
                :rules="'required|lBetween:3,255|CHECK_HTML'"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet type="block" >
          <LayoutField type="block" :required="true">
            <template #label>Thời hạn</template>
            <template #input>
              <BaseInput
                placeholder="Nhập thời hạn"
                v-model="period"
                name="Thời hạn"
                type="onlyNumberkey"
                :rules="'greaterThanZero|lBetween:0,10|CHECK_HTML'"
              />
            </template>
          </LayoutField>

          <LayoutField type="block" >
            <template #label>Tính theo</template>
            <template #input>
              <BaseSelect
                :options="warrantyPriodOptions"
                label="text"
                placeholder="Chọn thời gian"
                v-model="unit"
                @select="unitTmp = $event.id"
                :hideRemove="true"
                :validate="validate.unit"
              />
            </template>
          </LayoutField>  
        </LayoutFieldSet>
      </form>
    </validation-observer>

    <template slot="footer">
      <el-button type="text" @click="closePopup()"> Thoát </el-button>
      <el-button
        :loading="btnLoading"
        type="primary"
        @click="btnConfirmAddWarranty()"
      >
        Hoàn tất
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import VueCookies from 'vue-cookies'
import { ItemService } from "@/services/nextshop/item.service";

export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      btnLoading: false,
      visibleWarranty: false,
      name: '',
      unit: 'Tháng',
      unitTmp: 'THANG',
      period: 0,
      validate: {
        unit: ''
      },
      warrantyPriodOptions: [
        {id:"NGAY", text:"Ngày"},
        {id:"THANG", text:"Tháng"},
        {id:"NAM", text:"Năm"},
      ],
    };
  },

  methods: {
    async btnConfirmAddWarranty() {
      try {
        await this.$refs.observerWarranty.validate();

        let el = document.querySelector("#observerWarranty .is-invalid");
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
        } else {
          this.btnLoading = true;
          const req = {
            coMerchantId: VueCookies.get("MID"),
            unit: this.unitTmp,
            warrantyName: this.name.trim(),
            warrantyPeriod: this.period.trim(),
          };
          await ItemService.createWarranty(req).then(async (res) => {
            if (res.success) {
              // const params = await this.getListWarranty();
              this.btnLoading = false;
              this.$emit('getValue', res.data)
              this.name = ''
              this.unit = 'Tháng'
              this.unitTmp = 'THANG'
              this.period = 0
            }
          });
        }
      } catch (error) {
        console.log(error);
        this.$message.error("Thêm mới đơn vị lỗi, vui lòng thử lại");
        this.btnLoading = false;
      }
    },

    async getListWarranty() {
      try {
        const params = {
          coMerchantId: VueCookies.get("MID"),
          limit: 100,
          page: 1,
          warrantyName: '',
        };
        const response = await ItemService.getListWarranty(params);       
        if (response.success) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
        this.$message.error("Cập nhật danh sách đơn vị lỗi");
      }
    },

    closePopup() {
      this.name = ''
      this.unit = 'Tháng'
      this.unitTmp = 'THANG'
      this.period = 0
      this.validate.unit = ''
      this.$refs.observerWarranty.refs[`Tên chính sách bảo hành`].errors = [];
      this.$refs.observerWarranty.refs[`Thời hạn`].errors = [];
      this.visibleWarranty = false;
      this.$emit("getValue", null);
    },
  },

  watch: {
    isPopup: {
      handler: function () {
        this.visibleWarranty = this.isPopup;
      },
    },
  },
};
</script>

<style>
</style>